<template>
<v-container fill-height class="centered">
  <!-- <div style="position: absolute; top: 0; bottom: 0; right: 0; left: 0; background-color: #dddddd;">
  </div> -->
  <v-form v-model="valid" ref="login">
  <v-card
    class="mx-auto"
    min-width="250"
    max-width="440"
    elevation="0"
  >
    <v-card-title>
    <p>Login</p>
    </v-card-title>
    <v-card-text>
      <p>Verwenden Sie für die Anmeldung Ihr LUUCY-Login.<br/>
Falls Sie kein LUUCY-Konto haben, registrieren Sie sich unter <a href="https://luucy.ch/registration">luucy.ch/registration</a> und kontaktieren Sie uns unter <a href="mailto:support@luucy.ch">support@luucy.ch</a>.</p>
      <v-text-field
        type="text"
        name="email"
        v-model="email"
        :rules="emailRules"
        label="Email"
        outlined
        dense
      ></v-text-field>
      <v-text-field
        type="password"
        name="password"
        v-model="password"
        :rules="passwordRules"
        label="Password"
        outlined
        clearable
        dense
      ></v-text-field>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          color="primary"
          depressed
          tile
          block
          @click="register"
          v-bind:disabled="loading"
          type="submit"
        >
        Login
        </v-btn>
      </v-card-actions>
  </v-card>
  </v-form>
  <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      top
      color="red"
    >
      {{ infoMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Schlissen
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'

export default {
  name: 'Logon',
  data () {
    return {
      valid: false,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      password: '',
      passwordRules: [
        v => !!v || 'Password is required'
      ],
      loading: false,
      snackbar: false,
      infoMessage: 'Login fehler! Bitte überprüfen Sie Ihre Zugansdaten.',
      timeout: 2000
    }
  },
  methods: {
    cleanForm () {
      this.$refs.login.reset()
    },
    async register () {
      this.loading = true
      const responce = await AuthenticationService.login({
        email: this.email,
        password: this.password
      })

      // console.log(responce)

      if (responce) {
        if (responce.status === 200) {
          const r = responce.data
          this.$user.name = r.name
          this.$user.surname = r.surname
          this.$user.role = r.role
          this.$user.uid = r.uid
          this.$user.accessToken = r.accessToken
          this.$unit.name = r.activeUnit.name
          this.$unit.uuid = r.activeUnit.uuid
          this.$unit.processingStatus = r.activeUnit.settings.processingStatus
          this.$unit.processingStarted = r.activeUnit.settings.processingStarted
          // console.log(this.$unit)

          // TODO - validate token!!!
          this.$user.isAuthenticated = true
          this.loading = false
          this.$router.push('/')
        }
      } else {
        this.cleanForm()
        this.snackbar = true
        this.loading = false
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}
.v-card__text {
  color: black !important;
}
.justify-center {
  padding: 0px 15px 15px 15px;
}
.centered {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue